module.exports = __webpack_public_path__ + "static/media/pic8.5f0288f7.jpg";